// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.protcess-sertification {
    /* background-color: #f1f1f1; */
    padding-top: 80px;
    padding-bottom: 50px;
}
.protcess-sertification__head {
    font-size: 46px;
    font-weight: 700;
    text-align: center;
    color: #1e212c;
    margin-bottom: 60px;
}
.protcess-sertification__wrapper {
    display: flex;
    padding-bottom: 30px;
}

.protcess-sertification__list {
    width: 20%;
    margin-right: 40px;
}
.protcess-sertification__item {
    padding-bottom: 8px;
    padding-left: 20px;
    margin-bottom: 8px;
    color: #9a9ca5;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
}
.protcess-sertification__item:not(:last-child) {
    border-bottom: rgb(171, 184, 195) 1px solid;
}
.protcess-sertification__item:hover {
    /* color: #5185bf; */
    color: #0E0E4B;
}
.protcess-sertification__item--active {
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: -8px;
    background-color: #f1f1f1;
    color: #0E0E4B;
    border-bottom: none;
}

.protcess-sertification__content {
    width: 80%;
    padding: 30px;
    background-color: #fff;
    margin-top: -30px;
    border: 1px solid rgb(171, 184, 195);
}
.protcess-sertification__content:hover {
    box-shadow: 0px 7.94708px 24px -2px rgba(0, 0, 0, 0.25);
}
.protcess-sertification__title {
    font-size: 30px;
    margin-bottom: 20px;
}
.protcess-sertification__text {
    color: #787a80;
    font-size: 1rem;
    line-height: 1.6;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/components/protcess-sertification/index.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IAEI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,oBAAoB;IACpB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,oCAAoC;AACxC;AACA;IACI,uDAAuD;AAC3D;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".protcess-sertification {\n    /* background-color: #f1f1f1; */\n    padding-top: 80px;\n    padding-bottom: 50px;\n}\n.protcess-sertification__head {\n    margin-bottom: 50px;\n    font-size: 46px;\n    font-weight: 700;\n    text-align: center;\n    color: #1e212c;\n    margin-bottom: 60px;\n}\n.protcess-sertification__wrapper {\n    display: flex;\n    padding-bottom: 30px;\n}\n\n.protcess-sertification__list {\n    width: 20%;\n    margin-right: 40px;\n}\n.protcess-sertification__item {\n    padding-bottom: 8px;\n    padding-left: 20px;\n    margin-bottom: 8px;\n    color: #9a9ca5;\n    font-size: 18px;\n    font-weight: 700;\n    cursor: pointer;\n}\n.protcess-sertification__item:not(:last-child) {\n    border-bottom: rgb(171, 184, 195) 1px solid;\n}\n.protcess-sertification__item:hover {\n    /* color: #5185bf; */\n    color: #0E0E4B;\n}\n.protcess-sertification__item--active {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    margin-top: -8px;\n    background-color: #f1f1f1;\n    color: #0E0E4B;\n    border-bottom: none;\n}\n\n.protcess-sertification__content {\n    width: 80%;\n    padding: 30px;\n    background-color: #fff;\n    margin-top: -30px;\n    border: 1px solid rgb(171, 184, 195);\n}\n.protcess-sertification__content:hover {\n    box-shadow: 0px 7.94708px 24px -2px rgba(0, 0, 0, 0.25);\n}\n.protcess-sertification__title {\n    font-size: 30px;\n    margin-bottom: 20px;\n}\n.protcess-sertification__text {\n    color: #787a80;\n    font-size: 1rem;\n    line-height: 1.6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
